//@flow

import _ from 'lodash';

import { calcsRoute } from 'server2';

import type { ClientInterface } from 'server2';
import type { AuthContextInterface } from 'auth-context';

import type { QuotationInterface } from './contracts.flow';

type CalculatorPartialRestServiceOptions = {
	client: ClientInterface,
}

class CalculatorDataRestService {

	_client: ClientInterface;
	getDocumentTypes: () => Promise<any>;

	constructor ({ client }: CalculatorPartialRestServiceOptions) {
		this._client = client;
	}

	getDocumentTypes = () => this._client.get([
		calcsRoute.data,
		'documentTypes',
	]);
}

class CalculatorQuotationsRestService {
	
	_client: ClientInterface;
	create: () => Promise<any>;
	cloneByKey: () => Promise<any>;
	precalculate: () => Promise<any>;
	calculate: () => Promise<any>;
	createOrder: () => Promise<any>;
	prolongationByKey: () => Promise<any>;

	constructor ({ client }: CalculatorPartialRestServiceOptions) {
		this._client = client;
	}

	create = () => this._client.post([
		calcsRoute.quotations,
	]);

	cloneByKey = (key: string) => this._client.post([
		calcsRoute.quotations,
	], {
		query: {
			cloneByKey: key,
		},
	});

	precalculate = (body: QuotationInterface) => this._client.post([
		calcsRoute.quotations,
		body.ID,
		'precalculate',
	], { body });

	calculate = (body: QuotationInterface) => this._client.post([
		calcsRoute.quotations,
		body.ID,
		'calculate',
	], { body });

	createOrder = (ID: number) => this._client.post([
		calcsRoute.quotations,
		ID,
		'createOrder',
	]);

	prolongationByKey = (key: string) => this._client.post([
		calcsRoute.quotations,
	], {
		query: {
			prolongationByKey: key,
		},
	});
}

class CalculatorOrdersRestService {
	
	_client: ClientInterface;
	get: () => Promise<any>;

	constructor ({ client }: CalculatorPartialRestServiceOptions) {
		this._client = client;
	}

	get = (key: string) => this._client.get([
		calcsRoute.orders,
		key,
	]);
}

export type CalculatorRestServiceOptions = {
	calcPrefix?: string,
	calcRoute?: Array<string>,
	client: ClientInterface,
	authContext: AuthContextInterface,
}

export interface ICalculatorRestService {
	_client: ClientInterface;
	data: CalculatorDataRestService;
	quotations: CalculatorQuotationsRestService;
	orders: CalculatorOrdersRestService;
}

export default class CalculatorRestService
	implements ICalculatorRestService {
	_client: ClientInterface;
	data: CalculatorDataRestService;
	quotations: CalculatorQuotationsRestService;
	orders: CalculatorOrdersRestService;

	constructor ({ calcRoute, calcPrefix, client, authContext }: CalculatorRestServiceOptions) {

		const path = _.isArray(calcRoute) && !_.isEmpty(calcRoute)
			? calcRoute
			: [calcsRoute.prefix, calcPrefix];

		this._client = client
			.withAddedPath(path)
			.withAuthContext(authContext);

		const serviceOptions: CalculatorPartialRestServiceOptions = {
			client: this._client,
		};

		this.data = new CalculatorDataRestService(serviceOptions);

		this.quotations = new CalculatorQuotationsRestService(serviceOptions);

		this.orders = new CalculatorOrdersRestService(serviceOptions);
	}
}
